import * as fromCustomer from '../reducers/current-customer.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getCurrentCustomerState =
  createFeatureSelector<fromCustomer.State>('currentCustomer');
export const getCurrentCustomerLoading = createSelector(
  getCurrentCustomerState,
  fromCustomer.getCurrentCustomerLoading,
);
export const getCurrentCustomerError = createSelector(
  getCurrentCustomerState,
  fromCustomer.getCurrentCustomerError,
);
export const getCurrentCustomer = createSelector(
  getCurrentCustomerState,
  fromCustomer.getCurrentCustomer,
);
